import * as React from 'react';
import { FormGroup, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import FormSelect from '../../../components/common/FormSelect';
import FormValidationService from '../../../shared/form/FormValidationService';

interface IRoleSelectProps {
    onChange: (e: any) => void;
    roles: any[];
    role: number;
    error: any;
}

const RoleSelect = (props: IRoleSelectProps) => {
    return (
        <FormGroup
            className="required"
            validationState={FormValidationService.getValidationState(props.error)}
        >
            <ControlLabel>{Translate('plan-editors/form/role-select/label')}</ControlLabel>
            <FormSelect
                name="role"
                value={props.role as any}
                onChange={props.onChange}
                defaultTranslateKey="plan-editors/form/role-select/items/instructions"
            >
                {props.roles.map((r: any) => {
                    return (
                        <option key={r.id} value={r.id as any}>
                            {Translate(r.name)}
                        </option>
                    );
                })}
            </FormSelect>
            <HelpBlock>{props.error}</HelpBlock>
        </FormGroup>
    );
};

export default RoleSelect;
